import React, { useEffect, useRef, useState } from "react";
import "../../styles/BarMenuCatalog.css";
import { translateQrUi } from "../../services/menu/qrTranslations";
import useQrCatalogNavigation from "./useQrCatalogNavigation";

const hasSubcategories = (section) => (section?.subcategories || []).some(
  (subcategory) => subcategory.id !== "__general__" && subcategory.products?.length > 0
);

const getImage = (item) => item.imageUrl || item.products?.find((product) => product.imageUrl)?.imageUrl || "";

function ImageBar({ item, onClick, tx }) {
  const [failedImage, setFailedImage] = useState("");
  const image = getImage(item);
  return (
    <button type="button" className="qr-bar-tile" onClick={onClick}>
      {image && failedImage !== image && (
        <img src={image} alt="" loading="lazy" onError={() => setFailedImage(image)} />
      )}
      <span className="qr-bar-tile-shade" />
      <span className="qr-bar-tile-name">{tx(item.name)}</span>
      <span className="qr-bar-tile-count">{item.products.length} {tx(item.products.length === 1 ? "opcion" : "opciones")}</span>
    </button>
  );
}

const spanishText = (text) => translateQrUi("es", text);
export default function BarMenuCatalog({ sections, renderProductCard, primaryColor, layout = "bar", tx = spanishText, historyScope = "" }) {
  const { categoryId, subcategoryId, navigate } = useQrCatalogNavigation(historyScope);
  const headingRef = useRef(null);
  const previousPosition = useRef({ categoryId, subcategoryId });
  const category = sections.find((section) => section.id === categoryId);
  const subcategories = (category?.subcategories || []).filter((item) => item.products?.length);
  const subcategory = subcategories.find((item) => item.id === subcategoryId);
  const showSubcategories = category && hasSubcategories(category) && !subcategory;
  const products = category && !showSubcategories ? subcategory?.products || category.products : null;

  useEffect(() => {
    if (previousPosition.current.categoryId === categoryId && previousPosition.current.subcategoryId === subcategoryId) return;
    previousPosition.current = { categoryId, subcategoryId };
    headingRef.current?.focus({ preventScroll: true });
    headingRef.current?.scrollIntoView?.({ block: "start", behavior: "smooth" });
  }, [categoryId, subcategoryId]);

  return (
    <section className={`qr-bar-catalog${layout === "grid" ? " qr-grid-catalog" : ""}`} style={{ "--qr-bar-accent": primaryColor }} aria-label={tx("Carta por categorias")}>
      <nav className="qr-bar-navigation" aria-label={tx("Navegacion de la carta")}>
        {category && (
          <button type="button" onClick={() => navigate(subcategory ? category.id : null)}>
            {tx(subcategory ? "Volver a subcategorias" : "Volver a categorias")}
          </button>
        )}
        {subcategory && <button type="button" onClick={() => navigate(null)}>{tx("Todas las categorias")}</button>}
      </nav>
      <h2 tabIndex={-1} ref={headingRef} className="qr-bar-heading">
        {tx(subcategory?.name || category?.name || "Nuestra carta")}
      </h2>
      <p className="qr-bar-hint">
        {tx(products ? "Elegi tu plato y personalizalo a tu gusto." : showSubcategories ? "Elegi una subcategoria." : "Elegi una categoria para empezar.")}
      </p>
      {products ? (
        <div className="qr-bar-products">{products.map((product) => renderProductCard(product, false))}</div>
      ) : (
        <div className="qr-bar-tiles">
          {(showSubcategories ? subcategories : sections).map((item) => (
            <ImageBar key={item.id} item={item} tx={tx} onClick={() => navigate(showSubcategories ? category.id : item.id, showSubcategories ? item.id : null)} />
          ))}
        </div>
      )}
    </section>
  );
}
